const SESSION_STORAGE_KEY = 'bt_queue_session_id'
const TOKEN_PREFIX = 'wr_token_'
const DESTINATION_PREFIX = 'wr_destination_'
const RETURN_PREFIX = 'wr_return_'
const CURRENT_EVENT_KEY = 'wr_current_event_uuid'

export function getQueueSessionId() {
  let sessionId = sessionStorage.getItem(SESSION_STORAGE_KEY)
  if (!sessionId) {
    sessionId = crypto.randomUUID()
    sessionStorage.setItem(SESSION_STORAGE_KEY, sessionId)
  }
  return sessionId
}

export function getWaitingRoomToken(eventUuid) {
  if (!eventUuid) return null
  return sessionStorage.getItem(`${TOKEN_PREFIX}${eventUuid}`)
}

export function setWaitingRoomToken(eventUuid, token) {
  if (!eventUuid || !token) return
  sessionStorage.setItem(`${TOKEN_PREFIX}${eventUuid}`, token)
  sessionStorage.setItem(CURRENT_EVENT_KEY, eventUuid)
}

export function getCurrentWaitingRoomEventUuid() {
  return sessionStorage.getItem(CURRENT_EVENT_KEY)
}

export function clearWaitingRoomToken(eventUuid) {
  if (!eventUuid) return
  sessionStorage.removeItem(`${TOKEN_PREFIX}${eventUuid}`)
  sessionStorage.removeItem(`${RETURN_PREFIX}${eventUuid}`)
}

export function setWaitingRoomDestination(eventUuid, destination) {
  if (!eventUuid) return
  sessionStorage.setItem(`${DESTINATION_PREFIX}${eventUuid}`, destination)
}

export function getWaitingRoomDestination(eventUuid) {
  if (!eventUuid) return 'seated'
  return sessionStorage.getItem(`${DESTINATION_PREFIX}${eventUuid}`) || 'seated'
}

export function setWaitingRoomReturnPath(eventUuid, returnPath) {
  if (!eventUuid || !returnPath) return
  sessionStorage.setItem(`${RETURN_PREFIX}${eventUuid}`, returnPath)
}

export function getWaitingRoomReturnPath(eventUuid) {
  if (!eventUuid) return null
  return sessionStorage.getItem(`${RETURN_PREFIX}${eventUuid}`)
}

export function isWaitingRoomRequired(event) {
  return !!event?.waitingRoomEnabled
}

export function hasValidWaitingRoomToken(eventUuid) {
  return !!getWaitingRoomToken(eventUuid)
}

export function findWaitingRoomEvent(events = []) {
  return (
    (events || []).find(
      (event) =>
        event?.waitingRoomEnabled &&
        event?.uuid &&
        (event?.seoUrl || event?.slug) &&
        event?.shortCode
    ) || null
  )
}

export function getPurchasePath(slug, shortcode, destination, eventUuid) {
  const returnPath = eventUuid ? getWaitingRoomReturnPath(eventUuid) : null
  if (returnPath) return returnPath
  if (destination === 'ga') {
    return `/e/${slug}/${shortcode}`
  }
  return `/e/${slug}/${shortcode}/tickets`
}

export function getWaitingRoomPath(slug, shortcode) {
  return `/e/${slug}/${shortcode}/waiting-room`
}

export function redirectToWaitingRoom(
  navigate,
  slug,
  shortcode,
  eventUuid,
  destination = 'seated'
) {
  if (destination && typeof destination === 'object') {
    setWaitingRoomDestination(eventUuid, destination.type || 'return')
    if (destination.returnPath) {
      setWaitingRoomReturnPath(eventUuid, destination.returnPath)
    }
  } else {
    setWaitingRoomDestination(eventUuid, destination)
  }
  navigate(getWaitingRoomPath(slug, shortcode), {
    replace: true,
    state: {
      destination:
        typeof destination === 'object'
          ? destination.type || 'return'
          : destination,
    },
  })
}

/**
 * If any linked event requires the waiting room and this tab has no token,
 * redirect into that event's queue and return true.
 */
export function ensureWaitingRoomAccess(navigate, events, returnPath) {
  const event = findWaitingRoomEvent(events)
  if (!event) return false
  if (hasValidWaitingRoomToken(event.uuid)) return false
  const slug = event.seoUrl || event.slug
  redirectToWaitingRoom(navigate, slug, event.shortCode, event.uuid, {
    type: 'return',
    returnPath,
  })
  return true
}
